import state from "./state";
import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @returns {*}
   */
  async fetchTeacherArchivedList(context) {
    try {
      ApiService.setHeader();
      context.commit("setTeacherArchivedListBusy", true);
      const res = await ApiService.query("school/employee/teacher/archived", {
        params: {
          "page[size]": 30,
          "page[number]": state.pagination.current_page ?? 1,
          "filter[base]": state.filters.all,
        },
      });

      context.commit("setTeacherArchivedList", res.data.data);
      context.commit(
        "setTeacherArchivedListPagination",
        res.data.meta.pagination
      );
      return res;
    } catch (error) {
      console.error(error);

      throw Error("Failed.");
    } finally {
      context.commit("setTeacherArchivedListBusy", false);
    }
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherArchivedListBaseFilters(context, payload) {
    console.log("Name", payload.all);

    let curFilters = state.filters;
    curFilters.all = payload.all;

    context.commit("setTeacherArchivedListFilters", curFilters);
  },
};
